import { d as o, _ as t } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as r, createElementBlock as s, normalizeClass as n, normalizeStyle as a, createElementVNode as l } from "vue";
const c = o("arrow-right"), i = /* @__PURE__ */ l("path", {
  d: "m387.547 980.846 305.006-397.532a117.102 117.102 0 0 0 0-142.628L387.584 43.154a44.837 44.837 0 0 0-71.131 54.492l305.042 397.568a27.538 27.538 0 0 1 0 33.572L316.489 926.318a44.8 44.8 0 0 0 71.058 54.564",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), p = [
  i
];
function m(e, _, d, f, h, w) {
  return r(), s("svg", {
    class: n(e.classes),
    style: a(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, p, 6);
}
const v = /* @__PURE__ */ t(c, [["render", m]]);
export {
  v as default
};
